import { useQuery } from '@tanstack/react-query';
import { api } from 'src/services';
import { ServiceRequestStatus } from 'src/models';

export type GetServiceRequestStatusesResponse = {
  data: ServiceRequestStatus[];
};

export const useGetServiceRequestStatuses = () => {
  return useQuery({
    queryKey: ['serviceRequestStatuses'],
    queryFn: () =>
      api
        .get<GetServiceRequestStatusesResponse>('v3/service_request/statuses')
        .then(({ data }) => data.data),
  });
};
